/**
 * @author: subhasish.ghosh@zoom.us
 */

import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import React from "react";

const CustomDataGridToolBar = () => {
  return (
    <div
      style={{
        width: "100%",
        padding: "10px 15px",
      }}
    >
      <GridToolbarContainer
        style={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <GridToolbarColumnsButton
          slotProps={{
            tooltip: { title: "Select columns to display" },
            button: { variant: "outlined" },
          }}
        />
        {/* <GridToolbarFilterButton
              slotProps={{
                tooltip: { title: "Filter in table" },
                button: { variant: "outlined" },
              }}
            />
            <GridToolbarDensitySelector
              slotProps={{
                tooltip: { title: "Change density" },
                button: { variant: "outlined" },
              }}
            />
            <Box sx={{ flexGrow: 1 }} />
            <GridToolbarExport
              slotProps={{
                title: "Export Data",
                tooltip: { title: "Export data" },
                button: { variant: "outlined" },
              }}
            /> */}
      </GridToolbarContainer>
    </div>
  );
};

export default CustomDataGridToolBar;
